<div class="mb-7 grid place-items-center">
  <div class="tk-i-star-smile"></div>
</div>

<div class="text-xl font-semibold text-center">{{'survey.thank-you' | translate}}</div>

<div class="mt-1 mb-4 text-xs text-center">{{'survey.precious-opinion' | translate}}</div>

<button mat-flat-button color="primary" type="submit"
        class="flex justify-center items-center font-normal hover:font-normal" (click)="onCloseAfterSent()">
  <div class="text-sm text-white mx-12">{{'labels.close' | translate}}</div>
</button>

